<div class="layout">
  <osp-whitelabeled-component
    #whitelabelRef
    [componentKey]="WhitelabeledComponentKey.SIDEBAR_MENU"
    [defaultComponent]="SidebarComponent"
    class="layout__sidebar-container"
  />
  <!--'collapsed' | 'expanded' | 'expanded-fixed' -->
  <div class="layout__right-column" [ngClass]="'layout__right-column--sb-' + (this.sidebarState | async)">
    <div class="layout__topbar-container">
      <osp-topbar></osp-topbar>
    </div>
    <div class="layout__content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
